const FULL_NAME_HEADER_FIELDS = new Set(['latitude', 'longitude']);

export const getTrajectoryColumnHeaderTKey = (field: string, useShortColumnHeaders: boolean): string => {
  if (!useShortColumnHeaders || FULL_NAME_HEADER_FIELDS.has(field)) {
    return `TableHeaders.${field}`;
  }

  return `TableHeadersShort.${field}`;
};
